import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {AuthRESTService} from '../components/services/rest/auth-rest.service';

@Injectable()
export class UserLangResolverService {

    constructor(public translate: TranslateService, private rest: AuthRESTService) {
		this.translate = translate;
		this.rest.get('cas/translations/allcodes').subscribe((res: string[]) => 
			{
				this.translate.addLangs(res);
				this.translate.setDefaultLang(environment.translate.defaultLanguage);
				this.translate.use(localStorage.getItem('userLang') || this.translate.getDefaultLang());
			});
	}
	
	public changeLang(lang: string) {
		localStorage.setItem('userLang', lang);
		return this.translate.use(lang);
	}
}